import { Location } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { filter } from "rxjs";

@Component({
    selector: "app-checkout-page",
    templateUrl: "./checkout-page.component.html",
    styleUrls: ["./checkout-page.component.scss"],
    standalone: false,
})
export class CheckoutPageComponent implements OnInit {
    public title: string = "Shopping Cart";

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private location: Location,
    ) {}

    ngOnInit(): void {
        const currentUrl = document.location.href;
        if (currentUrl.includes("address") || currentUrl.includes("addAddress") || currentUrl.includes("editAddress")) {
            this.title = "Checkout";
        }
        this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
            let currentUrl = event.url;
            if (
                currentUrl.includes("address") ||
                currentUrl.includes("addAddress") ||
                currentUrl.includes("editAddress")
            ) {
                this.title = "Checkout";
            }
        });
    }

    public goBack(): void {
        this.location.back();
    }

    public goToCart(): void {
        this.router.navigate([`/checkout/cart`]);
    }
}
